export default "__VITE_ASSET__DEOldPQ3__"